/**
 * Tarjetas comerciales de planes visibles en la landing.
 *
 * Si el usuario no tiene sesión, el CTA lo manda al registro con el plan
 * preseleccionado; si ya tiene sesión, continúa al pago.
 */
import React from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext"; // Para verificar si el usuario está autenticado
import membershipPlans from "./membershipPlanData";
import "./MembershipPlans.scss";

const MembershipPlans = () => {
  const { currentUser } = useAuth(); // Obtener estado de autenticación
  const navigate = useNavigate();

  const handleSelectPlan = (plan) => {
    if (!currentUser) {
      // Si el usuario no está autenticado, redirigir al registro o login con el plan seleccionado
      navigate("/register", { state: { selectedPlan: plan } });
    } else {
      // Si el usuario está autenticado pero no tiene membresía activa, redirigir al pago
      // Aquí necesitarías verificar si tiene una membresía activa (puedes agregar esta lógica en el backend o al contexto)
      navigate("/payment", { state: { selectedPlan: plan } });
    }
  };

  return (
    <section id="membresias" className="membership-plans">
      <div className="contenedor-membresias">
        <div className="membership-heading">
          <span>Elige tu plan</span>
          <h2>Empieza hoy con una membresía pensada para ti</h2>
          <p>
            Entrenamiento, nutrición y herramientas de bienestar en un solo
            acompañamiento mensual.
          </p>
        </div>
        <div className="plans">
          {membershipPlans.map((plan) => (
            <article
              className={`plan ${plan.featured ? "plan--featured" : ""}`}
              key={plan.key}
            >
              <div className="plan-header">
                <span className="plan-badge">{plan.badge}</span>
                <h3>{plan.name}</h3>
                <p>{plan.summary}</p>
              </div>
              <div className="plan-price">
                <strong>{plan.formattedPrice}</strong>
                <span>{plan.period}</span>
              </div>
              <button
                className="btn-accion"
                onClick={() => handleSelectPlan(plan.key)}
              >
                Iniciar membresía
              </button>
              <div className="descr-plan">
                {plan.sections.map((section, sectionIndex) => (
                  <div className="plan-section" key={section.title}>
                    {sectionIndex > 0 && <div className="divider"></div>}
                    <h4>{section.title}</h4>
                    <ul>
                      {section.items.map((item) => (
                        <li key={item}>{item}</li>
                      ))}
                    </ul>
                  </div>
                ))}
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default MembershipPlans;
